import { Injectable, ɵpublishDefaultGlobalUtils } from '@angular/core';
import { environment } from 'src/environments/environment';

import { first, map } from 'rxjs/operators';
import { Observable, from } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { bo } from '@fullcalendar/core/internal-common';
import { User } from '../models/auth.models';
import { xml } from 'd3';
import moment from 'moment';
import { StringChain, isNull } from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class SoapService {
  private soapUrl = environment.SOAP_URL;
  soap: any;
  constructor(
    private httpClient: HttpClient,
  ) {
  }


  // Recursively loop through the DOM elements
  traverse(node: any, obj: any) {

    if (node.nodeType === Node.ELEMENT_NODE) {
      let newObj: any = {};
      if (node.hasChildNodes()) {
        if (node.getAttribute("xsi:type") == "SOAP-ENC:Array") {
          newObj = [];
          for (let childNode of node.childNodes) {
            const tempObj: any = {};
            this.traverse(childNode, tempObj);
            newObj.push(tempObj.item);

          }
        } else {
          for (let childNode of node.childNodes) {
            this.traverse(childNode, newObj);
          }
        }
      }
      if (Object.keys(newObj).length > 0) {
        obj[node.nodeName] = newObj;
      } else {
        obj[node.nodeName] = node.textContent.trim();
      }
    }
  }

  xmlToJs(xml: Document) {
    const obj = {};


    this.traverse(xml.documentElement, obj);
    return obj;
  }

  requestLogin(method: string, body: any): Observable<any> {

    const headers = {
      'Content-Type': 'text/xml'
    };

    const options: any = {
      observe: 'body',
      headers,
      responseType: 'text'
    };

    return this.httpClient.post(this.soapUrl, this.createBodyLogin(method, body), options).pipe(
      map((XML: any) => {
        const parser = new DOMParser();
        let Document = parser.parseFromString(XML, "text/xml");
        let js: any = this.xmlToJs(Document);
        js = js['SOAP-ENV:Envelope']['SOAP-ENV:Body'][`ns1:${method}Response`]['return'];
        return js
      }))
  }

  private createBodyLogin(method: string, body: any) {

    const keys = Object.keys(body);

    let params = '';

    for (let key of keys) {
      params += `<${key} xsi:type="xsd:string">${body[key]}</${key}>`
    }

    return `
      <soapenv:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:crm="http://www.vtiger.com/products/crm">
      <soapenv:Header/>
      <soapenv:Body>
        <crm:${method} soapenv:encodingStyle="http://schemas.xmlsoap.org/soap/encoding/">
            ${params}
        </crm:${method}>
      </soapenv:Body>
    </soapenv:Envelope>
       `;
  }
  request(method: string, body: any): Observable<any> {

    const headers = {
      'Content-Type': 'text/xml'
    };

    const options: any = {
      observe: 'body',
      headers,
      responseType: 'text'
    };
    return this.httpClient.post(this.soapUrl, this.createBody(method, body), options).pipe(
      map((XML: any) => {
        const parser = new DOMParser();
        let Document = parser.parseFromString(XML.replaceAll(`xmlns:ns1=""`, `xmlns:ns1="YOUR_NAMESPACE_HERE"`), "text/xml");

        let js: any = this.xmlToJs(Document);

        const envelope = js['SOAP-ENV:Envelope'];
        if (!envelope || !envelope['SOAP-ENV:Body']) {
          console.error("Resposta SOAP inesperada:", js);
          throw new Error("Resposta SOAP inválida ou sem Body.");
        }

        const body = envelope['SOAP-ENV:Body'];
        const response = body[`ns1:${method}Response`] || body[`${method}Response`];
        if (!response) {
          console.error(`Método ${method} não encontrado na resposta SOAP:`, body);
          throw new Error(`Resposta SOAP inválida para o método ${method}.`);
        }

        return response['return'];

      }))
  }

  private createBody(method: string, body: any) {

    const keys = Object.keys(body);

    let params = '';

    for (let key of keys) {

      params += `<${key} xsi:type="xsd:string">${(body[key]) ? body[key].toString().replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;') : body[key]}</${key}>`
    }
    return `
    <SOAP-ENV:Envelope SOAP-ENV:encodingStyle="http://schemas.xmlsoap.org/soap/encoding/"
    xmlns:SOAP-ENV="http://schemas.xmlsoap.org/soap/envelope/"
    xmlns:xsd="http://www.w3.org/2001/XMLSchema"
    xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
    xmlns:SOAP-ENC="http://schemas.xmlsoap.org/soap/encoding/">
    <SOAP-ENV:Body>
      <ns2582:${method}>      
        <__numeric_0>
            ${params}
        </__numeric_0>
        </ns2582:${method}>
      </SOAP-ENV:Body>
    </SOAP-ENV:Envelope>
       `;

  }

  getClients(customerid: string, sessionid: string, username: string, searchvalue: string) {


    return this.request('get_clients', {
      customerid: customerid,
      sessionid: sessionid,
      user_name: username,
      searchvalue: searchvalue
    }).pipe(
      map(client => {
        return client;
      })
    )
  }
  getTecnicos(customerid: string, sessionid: string, username: string) {
    return this.request('get_technicians', {
      customerid: customerid,
      sessionid: sessionid,
      username: username,
    }).pipe(
      map(tec => {
        return tec;
      })
    )
  }
  getGroups(customerid: string, sessionid: string) {
    return this.request('get_groups', {
      customerid: customerid,
      sessionid: sessionid,
    }).pipe(
      map(tec => {
        return tec;
      })
    )
  }
  getContractByClient(customerid: string, sessionid: string, username: string, clientid: string) {
    return this.request('get_client_contracts', {
      customerid: customerid,
      sessionid: sessionid,
      username: username,
      clientid: clientid,
    }).pipe(
      map(contract => {
        return contract;
      })
    )
  }
  saveTicket(customerid: string, sessionid: string, username: string, clientForm: any) {
    return this.request('save_ticket_general_data', {
      customerid: customerid,
      sessionid: sessionid,
      username: username,
      ticketid: clientForm.ticketid,
      accountid: clientForm.accountid,
      contractid: clientForm.contractid,
      email: clientForm.email,
      phone: clientForm.phone,
      sendemail: clientForm.send_email,
      internal: clientForm.internal,
      technicianid: clientForm.technicianid,
      description: clientForm.description,
      priority: clientForm.priority,
      status: clientForm.status,
      classification: clientForm.classification,
      tickettype: clientForm.tickettype,
      relationticketid: clientForm.relationticketid,
      askedby: clientForm.askedby,
      itinerarycosts: "",
      itinerarykms: "",
      cf_simplified: "No",
      title: "",
      scheduledate: (clientForm.scheduledate == '' || isNull(clientForm.scheduledate)) ? '' : moment(clientForm.scheduledate).format('yyyy-MM-DD'),
      starthour: (clientForm.starthour == '' || isNull(clientForm.starthour)) ? '' : moment(clientForm.starthour, 'HH:mm').format('HH:mm'),
      endhour: (clientForm.endhour == '' || isNull(clientForm.endhour)) ? '' : moment(clientForm.endhour, 'HH:mm').format('HH:mm'),
      fonte: clientForm.fonte,
      groupid: clientForm.groupid
    }).pipe(
      map(res => {
        if (res) {
        }

        return res;
      })
    )
  }
  saveTicketIntervention(customerid: string, sessionid: string, username: string, technicianid: string, clientForm: any) {
    return this.request('save_ticket_intervention', {
      customerid: customerid,
      sessionid: sessionid,
      username: username,
      ticketid: clientForm.ticketid,
      interventionid: clientForm.interventionid,
      duration: clientForm.duration_to_invoice,
      duration_to_invoice: clientForm.duration_to_invoice,
      comments: clientForm.comments,
      equipmentid: clientForm.equipmentid,
      service_typeid: clientForm.service_typeid,
      ticketintervention_tks_invoice: clientForm.ticketintervention_tks_invoice,
      endhour: (clientForm.endhourIntervention != '') ? moment(clientForm.endhourIntervention, 'HH:mm').format('HH:mm') : '',
      starthour: (clientForm.starthourIntervention != '') ? moment(clientForm.starthourIntervention, 'HH:mm').format('HH:mm') : '',
      equipmentdescription: clientForm.equipmentdescription,
      servicedescription: clientForm.servicedescription,
      serviceprice: clientForm.serviceprice,
      servicediscount: clientForm.servicediscount,
      servicefailuretype: clientForm.servicefailuretype,
      interventionstatus: clientForm.interventionstatus,
      interventionDate: (clientForm.interventionDate != '') ? moment(clientForm.interventionDate).format('YYYY-MM-DD') : '',
      technicianid: technicianid,
    }).pipe(
      map(res => {
        if (res) {
          this.saveTicketNotes(customerid, sessionid, username, clientForm).subscribe()
        }

        return res;
      })
    )
  }

  getTicketDetails(customerid: string, sessionid: string, username: string, ticketId: string) {
    return this.request('get_ticket_details_for_edit', {
      id: ticketId,
      customerid: customerid,
      sessionid: sessionid,
      username: username,
    }).pipe(
      map(ticketDetail => {

        return ticketDetail;
      })
    )
  }
  getTicketsList(
    customerid: string,
    sessionid: string,
    username: string,
    searchvalue: string,
    order: string,
    filter: string,
    extra: string,
    page: number,
    pageSize: number
  ) {
    return this.request('get_tickets_list', {
      customerid: customerid,
      sessionid: sessionid,
      user_name: username,
      searchvalue: searchvalue,
      order: order,
      filter: filter,
      extra: extra,
      page: page.toString(),
      pageSize: pageSize.toString()
    }).pipe(
      map(ticketsList => {

        return ticketsList;
      })
    )
  }
  getTasksList(customerid: string, sessionid: string, technicianId: string) {
    return this.request('get_calendar_activity', {
      customerid: customerid,
      sessionid: sessionid,
      techniciantask: technicianId,

    }).pipe(
      map(ticketsList => {
        return ticketsList;
      })
    )
  }
  getTasksListGeneral(customerid: string, sessionid: string, technicianId: string, tecnicoFilter: string, stateFilter: string, pesquisa: string,
    datacriacaode: string, datacriacaoate: string, datalimitede: string, datalimiteate: string, cliente: string, grupo: string) {
    return this.request('get_calendar_activity_list', {
      customerid: customerid,
      sessionid: sessionid,
      /* techniciantask: technicianId, */
      tecnico: tecnicoFilter,
      estado: stateFilter,
      pesquisa: pesquisa,
      datacriacaode: datacriacaode,
      datacriacaoate: datacriacaoate,
      datalimitede: datalimitede,
      datalimiteate: datalimiteate,
      cliente: cliente,
      grupo: grupo,
    }).pipe(
      map(ticketsList => {
        return ticketsList;
      })
    )
  }
  getTechnicianTimeline(customerid: string, sessionid: string, username: string, data: string, technicianid: string) {
    return this.request('get_technician_timeline', {
      id: customerid,
      sessionid: sessionid,
      username: username,
      data: data,
      technicianid: technicianid,
    }).pipe(
      map(services => {
        return services;
      })
    )
  }
  getInterventionList(ticketId: string, customerid: string, sessionid: string) {
    return this.request('get_ticket_interventions_for_edit', {
      id: ticketId,
      customerid: customerid,
      sessionid: sessionid,
    }).pipe(
      map(interventionList => {
        return interventionList;
      })
    )
  }
  duplicateTicketIntervention(customerid: string, sessionid: string, username: string, ticketid: string, technicianid: string, clientForm: any) {

    return this.request('save_ticket_intervention', {
      customerid: customerid,
      sessionid: sessionid,
      username: username,
      ticketid: ticketid,
      interventionid: "0",
      duration: clientForm.duration_to_invoice,
      duration_to_invoice: clientForm.duration_to_invoice,
      comments: clientForm.comments,
      equipmentid: clientForm.equipmentid,
      service_typeid: clientForm.service_typeid,
      ticketintervention_tks_invoice: clientForm.invoice,
      endhour: (clientForm.endhour != '') ? moment(clientForm.endhour, 'HH:mm').format('HH:mm') : '',
      starthour: (clientForm.starthour != '') ? moment(clientForm.starthour, 'HH:mm').format('HH:mm') : '',
      equipmentdescription: clientForm.equipmentdescription,
      servicedescription: clientForm.servicedescription,
      serviceprice: clientForm.serviceprice,
      servicediscount: clientForm.servicediscount,
      servicefailuretype: clientForm.servicefailuretype,
      interventionstatus: clientForm.interventionstatus,
      interventionDate: (clientForm.schedule_date != '') ? moment(clientForm.schedule_date).format('yyyy-MM-DD') : '',
      technicianid: technicianid,
    }).pipe(
      map(res => {
        return res;
      })
    )
  }
  getComboValues(customerid: string, sessionid: string, simplified: string) {
    return this.request('get_combo_values', {
      id: customerid,
      sessionid: sessionid,
      simplified: simplified,
    }).pipe(
      map(comboValues => {

        return comboValues;
      })
    )
  }
  getTicketsToRelation(customerid: string, sessionid: string, username: string, relatedTicketForm: any) {

    return this.request('get_tickets_to_relation', {
      customerid: customerid,
      sessionid: sessionid,
      ticketno: relatedTicketForm.ticketno,
      tickettechnician: relatedTicketForm.tickettechnician,
      ticketdate: relatedTicketForm.ticketdate,
      ticketequipment: relatedTicketForm.ticketequipment,
      ticketserialnumber: relatedTicketForm.ticketserialnumber,
      ticketid: relatedTicketForm.ticketid, //"742443",
      contractid: relatedTicketForm.contractid,
      accountid: relatedTicketForm.accountid, // cliente "742352",
      language: relatedTicketForm.language, // pt_pt
    }).pipe(
      map(ticketsToRelation => {
        return ticketsToRelation;
      })
    )
  }
  getTicketNotes(ticketId: string, customerid: string, sessionid: string) {
    return this.request('get_ticket_interventions_for_edit', {
      id: ticketId,
      customerid: customerid,
      sessionid: sessionid,
    }).pipe(
      map(interventionList => {
        return interventionList;
      })
    )
  }
  saveTicketNotes(customerid: string, sessionid: string, username: string, clientForm: any) {
    return this.request('save_ticket_notes', {
      customerid: customerid,
      sessionid: sessionid,
      username: username,
      ticketid: clientForm.ticketid,
      customer_notes: clientForm.customer_notes,
      internal_notes: clientForm.internal_notes,

    }).pipe(
      map(res => {
        if (res) {
        }

        return res;
      })
    )
  }
  deleteTicketIntervention(customerid: string, sessionid: string, username: string, interventionid: string) {

    return this.request('delete_ticket_intervention', {
      customerid: customerid,
      sessionid: sessionid,
      username: username,
      interventionid: interventionid
    }).pipe(
      map(res => {
        if (res) {
        }

        return res;
      })
    )
  }

  getTicketsTotals(customerid: string, sessionid: string, technicianid: string) {
    return this.request('get_tickets_totals', {
      customerid: customerid,
      sessionid: sessionid,
      technicianid: technicianid,
    }).pipe(
      map(contadores => {
        return contadores;
      })
    )
  }
  saveTask(customerid: string, sessionid: string, username: string, taskForm: any) {
    return this.request('save_calendar_activity', {
      customerid: customerid,
      sessionid: sessionid,
      username: username,
      activity_id: taskForm.activity_id,
      subject: taskForm.subject,
      date_start: (taskForm.date_start != '') ? moment(taskForm.date_start).format('yyyy-MM-DD') : '',
      due_date: (taskForm.due_date != '') ? moment(taskForm.due_date).format('yyyy-MM-DD') : '',
      status: taskForm.status,
      technicianid: taskForm.technicianid,
      techniciantask: taskForm.techniciantask,
      description: taskForm.description,
      clienteid: taskForm.clienteid,
      groupid: taskForm.groupid,
    }).pipe(
      map(res => {
        if (res) {
        }

        return res;
      })
    )
  }
  getWeekChart(customerid: string, sessionid: string, technicianid: string, data: string) {
    return this.request('get_week_chart', {
      customerid: customerid,
      sessionid: sessionid,
      technicianid: technicianid,
      data: data
    }).pipe(
      map(contadores => {
        return contadores;
      })
    )
  }

  getWeekChartAll(customerid: string, sessionid: string, data: string) {
    return this.request('get_week_chart_all', {
      customerid: customerid,
      sessionid: sessionid,
      data: data
    }).pipe(
      map(chart => {

        return chart;
      })
    )
  }

  cancelCurrentTicket(ticketId: string, customerid: string, sessionid: string) {
    return this.request('cancel_current_ticket', {
      ticketid: ticketId,
      id: customerid,
      sessionid: sessionid,
    }).pipe(
      map(res => {
        return res;
      })
    )
  }
  getTaskDetails(customerid: string, sessionid: string, activityid: string) {
    return this.request('get_calendar_activity_edit', {
      customerid: customerid,
      sessionid: sessionid,
      activityid: activityid,
    }).pipe(
      map(contadores => {
        return contadores;
      })
    )
  }

  deleteTask(customerid: string, sessionid: string, activityid: string) {
    return this.request('delete_calendar_activity', {
      customerid: customerid,
      sessionid: sessionid,
      activityid: activityid,
    }).pipe(
      map(task => {
        return task;
      })
    )
  }

  getTechnicianTimelineWeek(customerid: string, sessionid: string, username: string, data: string, dataEnd: string, tecnicoFilter: string, stateFilter: string, clienteFilter: string, classificacaoFilter: string,) {
    console.log(customerid)
    return this.request('get_technician_timeline_week', {
      id: customerid,
      sessionid: sessionid,
      username: username,
      data: data,
      dataEnd: dataEnd,
      tecnico: tecnicoFilter,
      estado: stateFilter,
      cliente: clienteFilter,
      classificacao: classificacaoFilter,
    }).pipe(
      map(services => {
        return services;
      })
    )
  }
  recoverPassword(email: string) {
    return this.request('send_mail_for_password', {
      email: email
    }).pipe(
      map(res => {
        return res;
      })
    )
  }
  changePassword(customerid: string, sessionid: string, username: string, password: string, oldpassword: string) {
    return this.request('change_password', {
      id: customerid,
      sessionid: sessionid,
      username: username,
      password: password,
      oldpassword: oldpassword,
      version: "6.0.0",
    }).pipe(
      map(res => {
        return res;
      })
    )
  }

  exportTicketsExcel(
    customerid: string,
    sessionid: string,
    username: string,
    filters: any
  ) {
    return this.request('export_tickets_excel', {
      customerid: customerid,
      sessionid: sessionid,
      username: username,
      datainicio: filters.startDate,
      datafim: filters.endDate,
      cliente: filters.customer,
      tecnico: filters.tecnico
    }).pipe(
      map(res => {
        return res;
      })
    );
  }

  getContractsList(
    customerid: string,
    sessionid: string,
    username: string,
    searchvalue: string,
    order: string,
    filter: string,
    extra: string,
    page: number = 1,
    pageSize: number = 20
  ) {
    return this.request('get_contracts_list', {
      customerid: customerid,
      sessionid: sessionid,
      user_name: username,
      searchvalue: searchvalue,
      order: order,
      filter: filter,
      extra: extra,
      page: page.toString(),
      pageSize: pageSize.toString()
    }).pipe(
      map(contractsList => {
        return contractsList;
      })
    );
  }

  getContractInterventions(
    customerid: string,
    sessionid: string,
    username: string,
    contractid: string
  ) {
    return this.request('get_contract_interventions', {
      customerid: customerid,
      sessionid: sessionid,
      username: username,
      contractid: contractid
    }).pipe(
      map(interventionsList => {
        return interventionsList;
      })
    );
  }

  getClientOrdersList(
    customerid: string,
    sessionid: string,
    username: string,
    searchvalue: string = '',
    order: string = '',
    filter: string = '',
    page: number = 1,
    pageSize: number = 20
  ) {
    return this.request('get_client_orders_list', {
      customerid: customerid,
      sessionid: sessionid,
      user_name: username,
      searchvalue: searchvalue,
      order: order,
      filter: filter,
      page: page.toString(),
      pageSize: pageSize.toString()
    }).pipe(
      map((ordersList: any) => {
        return ordersList;
      })
    );
  }

  saveClientOrder(customerid: string, sessionid: string, orderid: number, updated: any) {
    return this.request('save_client_order', {
      customerid: customerid,
      sessionid: sessionid,
      orderid: orderid.toString(),
      obs: updated.obs,
      id_estado: updated.id_estado.toString()
    }).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

    saveSupplierOrder(customerid: string, sessionid: string, orderid: number, updated: any) {
    return this.request('save_supplier_order', {
      customerid: customerid,
      sessionid: sessionid,
      orderid: orderid.toString(),
      obs: updated.obs,
      id_estado: updated.id_estado.toString()
    }).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getClientOrderLines(customerid: string, sessionid: string, orderid: string) {
    return this.request('get_client_order_lines', {
      customerid: customerid,
      sessionid: sessionid,
      orderid: orderid
    }).pipe(
      map((orderLines: any) => {
        return orderLines;
      })
    );
  }

  getSupplierOrdersList(
    customerid: string,
    sessionid: string,
    username: string,
    searchvalue: string = '',
    order: string = '',
    filter: string = '',
    page: number = 1,
    pageSize: number = 20
  ) {
    return this.request('get_supplier_orders_list', {
      customerid: customerid,
      sessionid: sessionid,
      user_name: username,
      searchvalue: searchvalue,
      order: order,
      filter: filter,
      page: page.toString(),
      pageSize: pageSize.toString()
    }).pipe(
      map((ordersList: any) => {
        return ordersList;
      })
    );
  }

  getSupplierOrderLines(customerid: string, sessionid: string, orderid: string) {
    return this.request('get_supplier_order_lines', {
      customerid: customerid,
      sessionid: sessionid,
      orderid: orderid
    }).pipe(
      map((orderLines: any) => {
        return orderLines;
      })
    );
  }

  getClientBudgetsList(
    customerid: string,
    sessionid: string,
    username: string,
    searchvalue: string = '',
    order: string = '',
    filter: string = '',
    page: number = 1,
    pageSize: number = 20
  ) {
    return this.request('get_client_budgets_list', {
      customerid: customerid,
      sessionid: sessionid,
      user_name: username,
      searchvalue: searchvalue,
      order: order,
      filter: filter,
      page: page.toString(),
      pageSize: pageSize.toString()
    }).pipe(
      map((budgetsList: any) => {
        return budgetsList;
      })
    );
  }

  getClientBudgetLines(customerid: string, sessionid: string, budgetid: string) {
    return this.request('get_client_budget_lines', {
      customerid: customerid,
      sessionid: sessionid,
      budgetid: budgetid
    }).pipe(
      map((budgetLines: any) => {
        return budgetLines;
      })
    );
  }

  getSalesOrderStatusList(customerid: string, sessionid: string) {
    return this.request('get_sales_order_status_list', {
      customerid: customerid,
      sessionid: sessionid
    }).pipe(
      map((statusList: any) => {
        return statusList;
      })
    );
  }

  getPurchasesOrderStatusList(customerid: string, sessionid: string) {
    return this.request('get_purchase_order_status_list', {
      customerid: customerid,
      sessionid: sessionid
    }).pipe(
      map((statusList: any) => {
        return statusList;
      })
    );
  }

  getSuppliers(customerid: string, sessionid: string) {
    return this.request('get_suppliers', {
      customerid: customerid,
      sessionid: sessionid,
    }).pipe(
      map(supplier => {
        return supplier;
      })
    )
  }

  getPowerBIReport(
  customerid: string,
  sessionid: string,
) {
  return this.request('get_powerbi_report', {
    customerid: customerid,
    sessionid: sessionid
    }).pipe(
    map(res => {
      return res[0];
    })
  );
}



  /************************************
   * Obter produtos (de ticket)
   * @param ticketId
   * @param customerid
   * @param sessionid
   * @returns
   */
  getTicketProducts(ticketId: string, customerid: string, sessionid: string) {
    return this.request('get_ticket_products_for_edit', {
      id: ticketId,
      customerid,
      sessionid,
    }).pipe(
      map((resp) => {
        if (!resp || resp === "") {
          return [];
        }
        return resp;
      })
    );
  }

  /************************************
   * Gravar produto (no ticket)
   * @param ticketId
   * @param customerid
   * @param sessionid
   * @param user_name
   * @param data
   * @returns
   */
  saveTicketProduct(id: string, ticketid: string, customerid: string, sessionid: string, user_name: string, data: any) {
    let fData: any = {
      productinterventionid: id,
      ticketid,
      customerid,
      sessionid,
      user_name,
      equipmentid: data.equipmentid,
      equipmentdescription: data.equipmentdescription,
      applied_productid: data.applied_productid,
      applied_serial_id: data.applied_serial_id,
      quantity: data.quantity,
      invoice: data.invoice,
      unit_price: data.price,
      discount: data.discount,
      comments: data.comments,
    };

    if (!fData.productinterventionid || fData.productinterventionid === '' || fData.productinterventionid === '0') {
      delete fData.productinterventionid;
    }

    return this.request('save_ticket_product', fData).pipe(
      map((resp) => {
        return resp;
      })
    );
  }

  /************************************
   * Obter produtos relacionados com equipamento
   * @param id
   * @param sessionid
   * @param user_name
   * @returns
   */
  deleteTicketProduct(productinterventionid: string,customerid: string, sessionid: string) {
    return this.request('delete_ticket_product', {
      productinterventionid,
      customerid,
      sessionid,
    }).pipe(
      map((resp) => {
        return resp;
      })
    );
  }

  /************************************
   * Obter equipamentos
   * @param customerid
   * @param sessionid
   * @param simplified
   * @returns
   */
  getTicketEquipments(customerid: string, sessionid: string, ticketid: string) {
    return this.request('get_combo_values_by_ticket', {
      id: customerid,
      sessionid,
      ticketid,
      simplified: 'false',
    }).pipe(
      map((resp) => {
        if (!resp || resp === "") {
          return [];
        }
        return this.normalizeComboValues(resp, 'equipmentid', 'equipment_name');
      })
    );
  }

  /************************************
   * Obter produtos relacionados com equipamento
   * @param customerid
   * @param sessionid
   * @param user_name
   * @param equipmentid
   * @returns
   */
  getEquipmentRelatedProducts(customerid: string, sessionid: string, user_name: string, equipmentid: string) {
    if (!equipmentid || equipmentid === '' || equipmentid === '0') {
      equipmentid = '';
    }

    return this.request('get_equipment_related_products', {
      customerid,
      sessionid,
      user_name,
      equipmentid,
    }).pipe(
      map((resp) => {
        if (!resp || resp === "") {
          return [];
        }
        return this.normalizeComboValues(resp, 'id', 'name');
      })
    );
  }

  /************************************
   * Obter números de série de equipamento
   * @param customerid
   * @param sessionid
   * @param productid
   * @returns
   */
  getProductSerialNumbers(customerid: string, sessionid: string, productid: string) {
    if (!productid || productid === '' || productid === '0') {
      productid = '';
    }

    return this.request('get_serial_numbers_from_product', {
      customerid,
      sessionid,
      productid,
    }).pipe(
      map((resp) => {
        if (!resp || resp === "") {
          return [];
        }
        return resp;
      })
    );
  }

  /************************************
   * Obter tipos de serviços de falhas
   * @param customerid
   * @param sessionid
   * @param simplified
   * @returns
   */
  getTicketServiceFailureType(customerid: string, sessionid: string, simplified: string) {
    return this.request('get_combo_values_by_ticket', {
      id: customerid,
      sessionid,
      simplified,
    }).pipe(
      map((resp) => {
        if (!resp || resp === "") {
          return [];
        }
        return this.normalizeComboValues(resp, 'failuretype_id', 'failuretype_description');
      })
    );
  }

  /************************************
   * Normalizar resposta das combos
   * @param resp raw response
   * @param idsProps ids property
   * @param labelsProps labels property
   * @returns normalized array with value | label
   */
  normalizeComboValues(resp: any, idsProps: string, labelsProps: string) {
    const ids = resp.find((item: any) => item[idsProps])?.[idsProps] ?? [];
    const descriptions = resp.find((item: any) => item[labelsProps])?.[labelsProps] ?? [];

    let data = [];
    for (let i = 0; i < ids.length; i++) {
      data[i] = { value: ids[i], label: descriptions[i] };
    }

    return data;
  }
}
